<template>
    <div>
        <div class="title">
            <Breadcrumb>
                <BreadcrumbItem>{{$t('resourceLifecycle.resourceServiceDirectory')}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.platformString}}</BreadcrumbItem>
                <BreadcrumbItem to="/resourceLifecycleManagement/resourceServiceDirectory">{{this.$route.query.lifecycleResourceTypeDesc}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- aws虚拟机 -->
        <amazon-virtual-machine-detail v-if="this.platform==0&&this.lifecycleResourceType==0" ref="amazonVirtualMachine" :amazonResourceApplicationBasicInfoForm="this.$route.query"></amazon-virtual-machine-detail>
        <!-- aws虚拟网络 -->
        <amazon-virtual-network-detail v-if="this.platform==0&&this.lifecycleResourceType==1" ref="amazonVirtualNetwork" :amazonResourceApplicationBasicInfoForm="this.$route.query"></amazon-virtual-network-detail>
        <!-- aws对象存储 -->
        <amazon-object-storage-detail v-if="this.platform==0&&this.lifecycleResourceType==2" ref="amazonObjectStorage" :amazonResourceApplicationBasicInfoForm="this.$route.query"></amazon-object-storage-detail>
        <!-- aws托管数据库 -->
        <amazon-managed-database-detail v-if="this.platform==0&&this.lifecycleResourceType==3" ref="amazonManagedDatabase" :amazonResourceApplicationBasicInfoForm="this.$route.query"></amazon-managed-database-detail>
        <!-- aws弹性IP -->
        <amazon-elastic-address-detail v-if="this.platform==0&&this.lifecycleResourceType==4" ref="amazonElasticAddress" :amazonResourceApplicationBasicInfoForm="this.$route.query"></amazon-elastic-address-detail>

        <!-- azure虚拟机 -->
        <azure-virtual-machine-detail v-if="this.platform==2&&this.lifecycleResourceType==0" ref="azureVirtualMachine" :azureResourceApplicationBasicInfoForm="this.$route.query"></azure-virtual-machine-detail>
        <!-- azure虚拟网络 -->
        <azure-virtual-network-detail v-if="this.platform==2&&this.lifecycleResourceType==1" ref="azureVirtualNetwork" :azureResourceApplicationBasicInfoForm="this.$route.query"></azure-virtual-network-detail>
        <!-- azure对象存储 -->
        <azure-object-storage-detail v-if="this.platform==2&&this.lifecycleResourceType==2" ref="azureObjectStorage" :azureResourceApplicationBasicInfoForm="this.$route.query"></azure-object-storage-detail>
        <!-- azure托管数据库 -->
        <azure-managed-database-detail v-if="this.platform==2&&(this.lifecycleResourceType==5||this.lifecycleResourceType==6||this.lifecycleResourceType==7)" ref="azureManagedDatabase" :azureResourceApplicationBasicInfoForm="this.$route.query"></azure-managed-database-detail>
        <!-- azure弹性IP -->
        <azure-elastic-address-detail v-if="this.platform==2&&this.lifecycleResourceType==4" ref="azureElasticAddress" :azureResourceApplicationBasicInfoForm="this.$route.query"></azure-elastic-address-detail>
    </div>
</template>

<script>
    // AWS
    import AmazonVirtualMachineDetail
    from "../../resource_lifecycle_management/resource_application/aws/virtual_machine/AmazonVirtualMachineDetail"
    import AmazonVirtualNetworkDetail
    from "../../resource_lifecycle_management/resource_application/aws/virtual_network/AmazonVirtualNetworkDetail"
    import AmazonObjectStorageDetail
    from "../../resource_lifecycle_management/resource_application/aws/object_storage/AmazonObjectStorageDetail"
    import AmazonManagedDatabaseDetail
    from "../../resource_lifecycle_management/resource_application/aws/managed_database/AmazonManagedDatabaseDetail"
    import AmazonElasticAddressDetail
    from "../../resource_lifecycle_management/resource_application/aws/elastic_ip/AmazonElasticAddressDetail"

    // Azure
    import AzureVirtualMachineDetail
    from "../../resource_lifecycle_management/resource_application/azure/virtual_machine/AzureVirtualMachineDetail"
    import AzureVirtualNetworkDetail
    from '../../resource_lifecycle_management/resource_application/azure/virtual_network/AzureVirtualNetworkDetail'
    import AzureObjectStorageDetail
    from '../../resource_lifecycle_management/resource_application/azure/object_storage/AzureObjectStorageDetail'
    import AzureManagedDatabaseDetail
    from '../../resource_lifecycle_management/resource_application/azure/managed_database/AzureManagedDatabaseDetail'
    import AzureElasticAddressDetail
    from '../../resource_lifecycle_management/resource_application/azure/elastic_ip/AzureElasticAddressDetail'

    export default {
        name: 'ResourceServiceDirectoryDetail',
        props: ['resourceRenewalDetailForm'],
        components: {
            AmazonVirtualMachineDetail,
            AmazonVirtualNetworkDetail,
            AmazonObjectStorageDetail,
            AmazonManagedDatabaseDetail,
            AmazonElasticAddressDetail,
            AzureVirtualMachineDetail,
            AzureVirtualNetworkDetail,
            AzureObjectStorageDetail,
            AzureManagedDatabaseDetail,
            AzureElasticAddressDetail
        },
        data() {
            return {
                modal_loadings: false,//下载
                platform: this.$route.query.platform,
                lifecycleResourceType: this.$route.query.lifecycleResourceType,
                oldLifecycleResource: {},
                cost: 0,
                process: '',
                renewalPeriod: '',
                describe: '',
                columnsFile: [
                {
                    title: this.$t("resourceLifecycle.fileName"),
                    key: 'fileName'
                },
                {
                    title: this.$t("resourceLifecycle.fileType"),
                    key: 'fileType'
                },
                {
                    title: this.$t('common.operation'),
                    slot: 'download',
                    "width": 100
                }],
                fileData: []
            }
        },
        mounted: function () {
        },
        methods: {
        }
    }
</script>

<style scoped>
    .ivu-form-item {
        margin-bottom: 0px !important;
        vertical-align: top;
        zoom: 1;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
</style>





// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_directory/ResourceServiceDirectoryDetail.vue